import { Stack } from '@mui/material';
import { ElementIssuesContext, SlicerAnswerOutcome } from 'api/element-issues';
import { IssueObjectType } from 'app/extreport/concierge/InconsistenciesCard';
import ClarificationsCarousel from './ClarificationsCarousel';

interface Props {
    context: ElementIssuesContext;
    onAnswer: (questionId: string, answer: string) => Promise<SlicerAnswerOutcome | void>;
    onSkip: (questionId: string) => Promise<void>;
    onClose: () => void;
    visible: boolean;
    objectType: IssueObjectType;
}

export default function ClarificationsSection({ context, onAnswer, onSkip, onClose, visible, objectType }: Props) {
    if (!context.isEditAccess || !visible || 0 === context.clarifyingQuestions.length) {
        return null;
    }

    return (
        <Stack
            spacing={1.5}
            sx={{
                flexShrink: 0,
                // Same bound as ReportConciergeContent: a tall carousel scrolls here
                // instead of squeezing the conversation area or getting clipped (the
                // card's overflow: hidden zeroes its flex min-height, so it must not
                // shrink).
                maxHeight: '60%',
                overflowY: 'auto',
                '& > *': { flexShrink: 0 },
                p: 1.5,
                borderBottom: '1px solid',
                borderColor: 'divider',
            }}
        >
            <ClarificationsCarousel
                questions={context.clarifyingQuestions}
                onAnswer={onAnswer}
                onSkip={onSkip}
                onClose={onClose}
                objectType={objectType}
            />
        </Stack>
    );
}
